const LocationMarker = ({lng, onClick, lat, mapIcon}) => {
    return (
        <div className="location-marker" onClick={onClick}>
            <img src={mapIcon} alt=""/>
        </div>
    )
}

export default LocationMarker
